export const AUTH_ENDPOINTS = {
  login: '/auth/login',
  register: '/auth/register',
  logout: '/auth/logout',
  confirmEmail: '/auth/confirm-email',
  profile: '/account/profile',
  nickname: '/account/nickname',
  forgotPassword: '/auth/forgot-password',
  resetPassword: '/auth/reset-password'
};

export interface LoginRequest {
  email: string;
  password: string;
}

export interface RegisterRequest {
  email: string;
  password: string;
  confirmPassword?: string;
  promoCode?: string;
  plan?: string;
}

export interface EmailConfirmationRequest {
  token: string;
  userId: string;
}

export interface ForgotPasswordRequest {
  email: string;
}

export interface ResetPasswordRequest {
  email: string;
  token: string;
  newPassword: string;
  confirmPassword: string;
}

export interface AuthResponse {
  success?: boolean;
  token?: string;
  message?: string;
  error?: string;
  userId?: string;
  email?: string;
  emailConfirmed?: boolean;
  requiresEmailConfirmation?: boolean;
}

/**
 * Получает токен авторизации из localStorage
 */
export const getAuthToken = (): string | null => {
  return localStorage.getItem('auth_token');
};